/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19.07"
        height="12.75"
        viewBox="0 0 19.07 12.75"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M9.53 0C3.06 0 .13 6.1.1 6.17l-.1.21.11.22c0 .06 3.2 6.15 9.42 6.15s9.4-6.09 9.43-6.15l.1-.22-.1-.21C18.93 6.1 16.01 0 9.53 0Zm0 11.75c-5 0-7.8-4.33-8.41-5.38C1.69 5.31 4.35 1 9.53 1s7.84 4.31 8.41 5.37c-.61 1.05-3.42 5.38-8.41 5.38Zm0-9.12a3.74 3.74 0 1 0 3.74 3.75 3.75 3.75 0 0 0-3.74-3.75Zm0 6.49a2.74 2.74 0 1 1 2.74-2.74 2.76 2.76 0 0 1-2.74 2.74Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'EyeIcon';

export default Icon;
